/* =================================================================== */
/* LOAMLABS WHEEL COMPONENT LIBRARY SCRIPT V8.1 (Bug Fixes)            */
/* =================================================================== */

document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('wheel-component-app');
    if (!rootElement) { return; }

    const API_URL = 'https://loamlabs-component-api.vercel.app/api/get-components';

    async function fetchComponentData() {
        try {
            const response = await fetch(API_URL);
            if (!response.ok) { throw new Error(`Network response was not ok: ${response.statusText}`); }
            return await response.json();
        } catch (error) {
            console.error('Failed to fetch component library:', error);
            rootElement.innerHTML = `<div class="ll-library-error"><p><strong>Error:</strong> Could not load the wheel component library.</p><p>Please try again later.</p></div>`;
            return null;
        }
    }

    function processData(data) {
        const library = { rims: {}, hubs: {}, spokes: {}, nipples: {} };

        // --- RIMS ---
        if (data.rims) {
            const rimsByTitle = data.rims.reduce((acc, item) => {
                if (item.Vendor && item.Title) {
                    if (!acc[item.Title]) { acc[item.Title] = []; }
                    acc[item.Title].push(item);
                }
                return acc;
            }, {});
            Object.values(rimsByTitle).forEach(variants => {
                const representativeItem = variants[0];
                const sizes = {};
                variants.forEach(variant => {
                    const size = variant['Option1 Value'];
                    if (!sizes[size]) {
                        sizes[size] = { specs: variant, spokeCounts: new Set() };
                    }
                    sizes[size].spokeCounts.add(variant['Option2 Value']);
                });
                representativeItem.sizes = sizes;
                if (!library.rims[representativeItem.Vendor]) { library.rims[representativeItem.Vendor] = []; }
                library.rims[representativeItem.Vendor].push(representativeItem);
            });
            Object.keys(library.rims).forEach(vendor => library.rims[vendor].sort((a, b) => a.Title.localeCompare(b.Title)));
        }

        // --- HUBS ---
        if (data.hubs) {
            const hubsByTitle = data.hubs.reduce((acc, item) => {
                if (item.Vendor && item.Title) {
                    if (!acc[item.Title]) { acc[item.Title] = []; }
                    acc[item.Title].push(item);
                }
                return acc;
            }, {});
            Object.values(hubsByTitle).forEach(variants => {
                const representativeItem = variants[0];
                if (!library.hubs[representativeItem.Vendor]) { library.hubs[representativeItem.Vendor] = []; }
                library.hubs[representativeItem.Vendor].push(variants);
            });
            Object.keys(library.hubs).forEach(vendor => library.hubs[vendor].sort((a, b) => a[0].Title.localeCompare(b[0].Title)));
        }

        // --- SPOKES ---
        if (data.spokes) {
            data.spokes.forEach(spoke => {
                if (spoke.Vendor && spoke.Title) {
                    if (!library.spokes[spoke.Vendor]) { library.spokes[spoke.Vendor] = []; }
                    library.spokes[spoke.Vendor].push(spoke);
                }
            });
            Object.keys(library.spokes).forEach(vendor => library.spokes[vendor].sort((a, b) => a.Title.localeCompare(b.Title)));
        }

        // --- NIPPLES ---
        if (data.nipples) {
            const nipplesByTitle = data.nipples.reduce((acc, item) => {
                if (item.Vendor && item.Title) {
                    if (!acc[item.Title]) { acc[item.Title] = []; }
                    acc[item.Title].push(item);
                }
                return acc;
            }, {});
            Object.values(nipplesByTitle).forEach(variants => {
                const representativeItem = variants[0];
                if (!library.nipples[representativeItem.Vendor]) { library.nipples[representativeItem.Vendor] = []; }
                library.nipples[representativeItem.Vendor].push(variants);
            });
            Object.keys(library.nipples).forEach(vendor => library.nipples[vendor].sort((a, b) => a[0].Title.localeCompare(b[0].Title)));
        }

        return library;
    }

    function renderLibrary(library) {
        const seoBoost = document.getElementById('ll-library-seo-boost');
        if (seoBoost) { seoBoost.remove(); }
        const componentOrder = [
            { key: 'rims', title: 'Rims' },
            { key: 'hubs', title: 'Hubs' },
            { key: 'spokes', title: 'Spokes' },
            { key: 'nipples', title: 'Nipples' }
        ];

        let html = componentOrder.map(({ key, title }) => `
            <details class="ll-component-category" id="category-${key}">
                <summary class="ll-category-summary">${title}</summary>
                <div class="ll-category-content">
                    ${renderComponentType(library[key], key)}
                </div>
            </details>
        `).join('');

        rootElement.innerHTML = `<div class="ll-library-container">${html}</div>`;
    }

    function renderComponentType(vendors, typePrefix) {
    const sortedVendors = Object.keys(vendors).filter(v => v && typeof v === 'string' && v.trim() !== '').sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
    if (sortedVendors.length === 0) return '<h2></h2><p>No components found for this category.</p>';

    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');
    const availableLetters = new Set(sortedVendors.map(v => v[0].toUpperCase()));
    const azNav = `<nav class="ll-az-nav" id="${typePrefix}-az-nav">${alphabet.map(letter => availableLetters.has(letter) ? `<a href="#${typePrefix}-${letter}">${letter}</a>` : `<span>${letter}</span>`).join('')}</nav>`;
    
    let currentLetter = '';
    const vendorHTML = sortedVendors.map(vendor => {
        const firstLetter = vendor[0].toUpperCase();
        let letterHeader = '';
        if (firstLetter !== currentLetter) {
            currentLetter = firstLetter;
            letterHeader = `<h3 id="${typePrefix}-${currentLetter}" class="ll-letter-header">${currentLetter}</h3>`;
        }
        let hubTypeFilters = '';
        if (typePrefix === 'hubs') {
            const hubTypes = new Set(vendors[vendor].flat().map(hub => hub['Metafield: custom.hub_type [single_line_text_field]']));
            if (hubTypes.size > 1) {
                hubTypeFilters = `<div class="ll-hub-type-filters"><button class="hub-type-filter-btn active" data-filter="All">All</button>${[...hubTypes].sort().map(type => `<button class="hub-type-filter-btn" data-filter="${type}">${type}</button>`).join('')}</div>`;
            }
        }

        let componentListHTML;
        if (typePrefix === 'nipples') {
            const allVariants = vendors[vendor].flat();
            componentListHTML = allVariants.map(variant => {
                // Pass 'nipples' as the type
                return `<li class="ll-component-item--no-accordion">${generateSpecTableHTML([variant], 'nipples')}</li>`;
            }).join('');
        } else {
            componentListHTML = vendors[vendor].map(componentData => {
                 const title = Array.isArray(componentData) ? componentData[0].Title : componentData.Title;
                 const hubType = (Array.isArray(componentData) ? componentData[0] : componentData)['Metafield: custom.hub_type [single_line_text_field]'] || '';
                 // Pass the current category type (rims, hubs, or spokes)
                 return `<li data-hub-type="${hubType}"><details class="ll-component-details"><summary class="ll-component-title">${title}</summary>${generateSpecTableHTML(componentData, typePrefix)}</details></li>`;
            }).join('');
        }

        return `${letterHeader}<details class="ll-vendor-section"><summary class="ll-vendor-title">${vendor}</summary>${hubTypeFilters}<ul class="ll-component-list">${componentListHTML}</ul></details>`;
    }).join('');

    return azNav + vendorHTML;
}

    function generateCalculatorLink(component, type, position, size = null) {
    if (typeof LZString === 'undefined' || !LZString.compressToBase64) {
         console.error("LZString library not available or invalid.");
         return "/pages/spoke-calculator";
    }
    
    const state = { pos: position };

    if (type === 'rims') {
        state.r_vid = component.Vendor;
        state.r_mid = component.Title;
        if (size) {
             state.r_varid = `${component.Title}-${size}`;
        }
    } else { 
        state.h_vid = component.Vendor;
        state.h_mid = component.Title;
        state.h_varid = component.Title;
    }
    const jsonString = JSON.stringify(state);
    const compressedString = LZString.compressToBase64(jsonString);
    return `/pages/spoke-calculator#${compressedString}`;
}

    function generateSpecTableHTML(componentData, type) {
    const representative = Array.isArray(componentData) ? componentData[0] : componentData;
    let tableHTML = '';

    const getWeight = (comp) => {
        const vWeight = comp['Variant Metafield: custom.weight_g [number_decimal]'];
        if (vWeight) return `${vWeight}g`;
        const pWeight = comp['Metafield: custom.weight_g [number_decimal]'];
        return pWeight ? `${pWeight}g` : 'N/A';
    };
    const addRow = (rows, label, value) => {
        if (value !== null && value !== undefined && value !== '') return rows + `<tr><td>${label}</td><td>${value}</td></tr>`;
        return rows;
    };

    const generateProductPageButton = (component) => {
        if (component.ProductURL) {
            return `<a href="${component.ProductURL}" target="_blank" class="ll-calc-link-btn ll-product-page-link">Visit Product Page</a>`;
        }
        return '';
    };
    
    // --- RIM SECTION ---
    if (type === 'rims' && representative.sizes) {
        Object.keys(representative.sizes).sort().reverse().forEach(size => {
            const sizeData = representative.sizes[size];
            const variant = sizeData.specs;
            let rows = '';
            
            rows = addRow(rows, 'ERD', variant['Variant Metafield: custom.rim_erd [number_decimal]']);
            rows = addRow(rows, 'Spoke Hole Offset', variant['Metafield: custom.rim_spoke_hole_offset [number_decimal]']);
            const washerPolicy = variant['Metafield: custom.rim_washer_policy [single_line_text_field]'];
            const washerThickness = variant['Metafield: custom.nipple_washer_thickness [number_decimal]'];
            if (washerPolicy) {
                 rows = addRow(rows, 'Washer Policy', washerPolicy);
                 if (washerPolicy === 'Mandatory' && washerThickness) { rows = addRow(rows, 'Washer Thickness', `${washerThickness}mm`); }
            }
            rows = addRow(rows, 'Available Spoke Counts', Array.from(sizeData.spokeCounts).sort((a,b) => parseInt(a) - parseInt(b)).join(', '));
            rows = addRow(rows, 'Weight', getWeight(variant));

            let frontLink = '', rearLink = '';
            const position = variant['Variant Metafield: custom.wheel_spec_position [single_line_text_field]'];
            
            if (position === 'Front' || position === 'Front/Rear') {
                frontLink = `<a href="${generateCalculatorLink(variant, 'rims', 'front', size)}" target="_blank" class="ll-calc-link-btn">Use in Front Wheel Calc</a>`;
            }
            if (position === 'Rear' || position === 'Front/Rear') {
                rearLink = `<a href="${generateCalculatorLink(variant, 'rims', 'rear', size)}" target="_blank" class="ll-calc-link-btn">Use in Rear Wheel Calc</a>`;
            }
            
            const productPageButton = generateProductPageButton(representative);
            tableHTML += `<div class="ll-variant-spec-block"><h5 class="ll-variant-title">${size}</h5><table class="ll-spec-table"><tbody>${rows}</tbody></table><div class="ll-spec-actions">${productPageButton}<div class="ll-calc-actions-group">${frontLink}${rearLink}</div></div></div>`;
        });

    // --- HUB SECTION ---
    } else if (type === 'hubs') {
        const hubModelRepresentative = componentData[0];
        let rows = '';

        const hubType = hubModelRepresentative['Metafield: custom.hub_type [single_line_text_field]'];
        rows = addRow(rows, 'Hub Type', hubType);
        rows = addRow(rows, 'Flange Dia. (L/R)', `${hubModelRepresentative['Metafield: custom.hub_flange_diameter_left [number_decimal]']} / ${hubModelRepresentative['Metafield: custom.hub_flange_diameter_right [number_decimal]']}`);
        rows = addRow(rows, 'Flange Offset (L/R)', `${hubModelRepresentative['Metafield: custom.hub_flange_offset_left [number_decimal]']} / ${hubModelRepresentative['Metafield: custom.hub_flange_offset_right [number_decimal]']}`);
        
        // New Lacing & Distribution Logic
        const crossL = hubModelRepresentative['Variant Metafield: custom.hub_lacing_cross_left [number_decimal]'];
        const crossR = hubModelRepresentative['Variant Metafield: custom.hub_lacing_cross_right [number_decimal]'];
        const distL = hubModelRepresentative['Variant Metafield: custom.hub_spoke_count_left [number_decimal]'];
        const distR = hubModelRepresentative['Variant Metafield: custom.hub_spoke_count_right [number_decimal]'];
        
        const hasValue = (v) => v !== null && v !== undefined && v !== '' && v !== '-';

        if (hasValue(crossL) || hasValue(crossR)) {
            rows = addRow(rows, 'Cross Pattern (L/R)', `${hasValue(crossL) ? crossL : 'N/A'} / ${hasValue(crossR) ? crossR : 'N/A'}`);
        }

        if (hasValue(distL) || hasValue(distR)) {
            rows = addRow(rows, 'Spoke Distribution (L/R)', `${hasValue(distL) ? distL : 'N/A'} / ${hasValue(distR) ? distR : 'N/A'}`);
        }

        if (hubType === 'Straight Pull') {
            rows = addRow(rows, 'Spoke Offset (L/R)', `${hubModelRepresentative['Variant Metafield: custom.hub_sp_offset_spoke_hole_left [number_decimal]']} / ${hubModelRepresentative['Variant Metafield: custom.hub_sp_offset_spoke_hole_right [number_decimal]']}`);
        } else {
            rows = addRow(rows, 'Spoke Hole Dia.', hubModelRepresentative['Metafield: custom.hub_spoke_hole_diameter [number_decimal]']);
        }

        const spokeCounts = new Set(componentData.map(variant => variant['Option1 Value']));
        rows = addRow(rows, 'Available Spoke Counts', Array.from(spokeCounts).sort((a,b) => parseInt(a) - parseInt(b)).join(', '));
        rows = addRow(rows, 'Weight', getWeight(hubModelRepresentative));

        let frontLink = '', rearLink = '';
        const position = hubModelRepresentative['Variant Metafield: custom.wheel_spec_position [single_line_text_field]'];

        if (position === 'Front' || position === 'Front/Rear') {
            frontLink = `<a href="${generateCalculatorLink(hubModelRepresentative, 'hubs', 'front')}" target="_blank" class="ll-calc-link-btn">Use in Front Wheel Calc</a>`;
        }
        if (position === 'Rear' || position === 'Front/Rear') {
            rearLink = `<a href="${generateCalculatorLink(hubModelRepresentative, 'hubs', 'rear')}" target="_blank" class="ll-calc-link-btn">Use in Rear Wheel Calc</a>`;
        }

        const productPageButton = generateProductPageButton(hubModelRepresentative);

        tableHTML = `<div class="ll-variant-spec-block">
                        <table class="ll-spec-table"><tbody>${rows}</tbody></table>
                        <div class="ll-spec-actions">${productPageButton}<div class="ll-calc-actions-group">${frontLink}${rearLink}</div></div>
                     </div>`;

    // --- SPOKE SECTION ---
    } else if (type === 'spokes') {
        let rows = '';
        const spoke = representative;
        rows = addRow(rows, 'Type', spoke['Metafield: custom.spoke_type [single_line_text_field]']);
        rows = addRow(rows, 'Diameter', spoke['Metafield: custom.spoke_diameter_spec [single_line_text_field]']);
        rows = addRow(rows, 'Weight', getWeight(spoke));
        rows = addRow(rows, 'Cross Section Area', `${spoke['Metafield: custom.spoke_cross_section_area_mm2 [number_decimal]']} mm²`);
        
        const productPageButton = generateProductPageButton(spoke);

        tableHTML += `<div class="ll-variant-spec-block">
            <h5 class="ll-variant-title">${spoke['Metafield: custom.spoke_model_group [single_line_text_field]'] || spoke.Title}</h5>
            <table class="ll-spec-table"><tbody>${rows}</tbody></table>
            <div class="ll-spec-actions">${productPageButton}</div>
            <p class="ll-spec-table-note">Note: Weight is for a 260mm reference length.</p>
        </div>`;

    // --- NIPPLE SECTION ---
    } else if (type === 'nipples') {
        const productPageButton = generateProductPageButton(representative);
        
        let variantHTML = componentData.map(variant => {
            let rows = '';
            rows = addRow(rows, 'Head Height', `${variant['Variant Metafield: custom.nipple_head_height_mm [number_decimal]']}mm`);
            rows = addRow(rows, 'Weight', getWeight(variant));

            return `<div class="ll-variant-spec-block">
                <h5 class="ll-variant-title">${variant['Option1 Value']}</h5>
                <table class="ll-spec-table"><tbody>${rows}</tbody></table>
            </div>`;
        }).join('');

        tableHTML = `<div class="ll-spec-actions">${productPageButton}</div>${variantHTML}`;
    }
    return `<div class="ll-spec-table-wrapper">${tableHTML}</div>`;
}

    function initializeNavigation() {
        const stickyHeader = document.getElementById('ll-sticky-filters');
        // Add a 10px buffer for better spacing
        const headerOffset = stickyHeader ? stickyHeader.offsetHeight + 10 : 70;

        const handleNavClick = (event) => {
            const categoryLink = event.target.closest('.ll-sticky-nav-link');
            const azLink = event.target.closest('.ll-az-nav a');

            if (categoryLink) {
                event.preventDefault();
                const targetId = `category-${categoryLink.dataset.target}`;
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    document.querySelectorAll('.ll-component-category').forEach(el => {
                        if (el.id !== targetId) el.open = false;
                    });
                    targetElement.open = true;
                    
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    
                    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
            } else if (azLink) {
                // BUG FIX: Custom scrolling for A-Z links
                event.preventDefault();
                const targetId = azLink.getAttribute('href');
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    
                    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
                }
            }
        };

        document.body.addEventListener('click', handleNavClick);

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const id = entry.target.getAttribute('id');
                const navLink = document.querySelector(`.ll-sticky-nav-link[data-target="${id.replace('category-','')}"`);
                if (navLink) {
                    if (entry.isIntersecting) {
                        document.querySelectorAll('.ll-sticky-nav-link').forEach(link => link.classList.remove('active'));
                        navLink.classList.add('active');
                    }
                }
            });
        }, { rootMargin: `-${headerOffset}px 0px -80% 0px` });

        document.querySelectorAll('.ll-component-category').forEach(section => {
            observer.observe(section);
        });
    }

    async function init() {
        const data = await fetchComponentData();
        if (data) {
            const library = processData(data);
            renderLibrary(library);
            initializeNavigation();
        }
    }

    init();
});